import React from 'react';
import {CreditInfo} from '../../models/creditInfo.model';
import {CreditInfoCardHeader} from './CreditInfoCardHeader';
import {CreditInfoMetricsGrid} from './CreditInfoMetricsGrid';
import {CreditInfoStatusSection} from './CreditInfoStatusSection';
import {CreditInfoAdditionalInfo} from './CreditInfoAdditionalInfo';
import {formatCurrency, formatPercentage} from '../../../../Presentation/utils/numberUtils';

interface CreditInfoCardProps {
  creditInfo: CreditInfo;
  storeId?: number;
  onEditClick?: () => void;
}

export const CreditInfoCard: React.FC<CreditInfoCardProps> = ({creditInfo, storeId, onEditClick}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
      <CreditInfoCardHeader onEditClick={onEditClick} />

      <CreditInfoMetricsGrid
        creditInfo={creditInfo}
        formatCurrency={formatCurrency}
        formatPercentage={formatPercentage}
      />

      {/* تقييم الدفع وحالة الدفع */}
      <CreditInfoStatusSection creditInfo={creditInfo} />

      {/* معلومات إضافية */}
      <CreditInfoAdditionalInfo creditInfo={creditInfo} />
    </div>
  );
};
